import React from 'react'

const SvgSendOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.992 2.259c-.899-.378-1.828-.357-2.668.16l-.002.002c-.842.521-1.272 1.346-1.32 2.32C2 4.76 2 4.776 2 4.792V19.21l.001.045c.044.978.481 1.801 1.323 2.322.84.518 1.769.544 2.668.165a.992.992 0 00.06-.027l14.423-7.207a.987.987 0 00.08-.045c.895-.555 1.445-1.39 1.445-2.46s-.55-1.906-1.445-2.461a.998.998 0 00-.08-.045L6.052 2.287c-.02-.01-.04-.02-.06-.028zM4.374 4.122c-.217.134-.35.32-.374.698v3.803L12.443 12 4 15.377v3.807c.02.368.15.552.376.692.224.138.458.177.814.034l14.346-7.168c.372-.242.464-.474.464-.74 0-.265-.092-.497-.464-.739L5.19 4.093c-.362-.146-.596-.106-.816.03z'
    />
  </svg>
)

export default SvgSendOutline
